import React from 'react';

// routes
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PrivateRouteAlcohol from './PrivateRouteAlcohol';
import PrivateRouteMomthera from './PrivateRouteMomthera';

// layout
import DashboardLayout from '../components/layout/DashboardLayout';

// spec
import ProjectSpec from '../pages/signin/ProjectSpec';
// pages
import SignInPage from '../pages/signin/SignInPage';
import SignInPageV2 from '../pages/signin/SignInPageV2';
import ChangePWPage from '../pages/signin/ChangePWPage';
import SearchAccount from '../pages/signin/SearchAccount';
import SignUpPage from '../pages/signin/SignUpPage';
import EmptyPage from '../pages/EmptyPage';

import AlcoholDashboardPage from '../pages/alcohol/dashboard/AlcoholDashboardPage';
import AlcoholPatientManageListPage from '../pages/alcohol/patientManage/AlcoholPatientManageListPage';
import AlcoholPatientManageDetailPage from '../pages/alcohol/patientManage/AlcoholPatientManageDetailPage';
// import AlcoholSettingInstitution from '../pages/alcohol/systemSetting/AlcoholSettingInstitution';
// import AlcoholSettingUser from '../pages/alcohol/systemSetting/AlcoholSettingUser';
// import AlcoholSettingAuth from '../pages/alcohol/systemSetting/AlcoholSettingAuth';
import AlcoholNotificationList from '../pages/alcohol/pushNotification/AlcoholNotificationList';
import SignInRefusePage from '../pages/signin/SignInRefusePage';
import AlcoholMyPageMain from '../pages/alcohol/mypage/AlcoholMyPageMain';
import AlcoholMyPageWithdrawal from '../pages/alcohol/mypage/AlcoholMyPageWithdrawal';
import AlcoholMyPageModifyProfile from '../pages/alcohol/mypage/AlcoholMyPageModifyProfile';
import AlcoholMyPageModifyPW from '../pages/alcohol/mypage/AlcoholMyPageModifyPW';
import AlcoholMyPageLoginHistory from '../pages/alcohol/mypage/AlcoholMyPageLoginHistory';
import AlcoholMyPageActivityHistory from '../pages/alcohol/mypage/AlcoholMyPageActivityHistory';

import HearroDashboardPage from '../pages/hearro/dashboard/HearroDashboardPage';
import HearroPatientManageListPage from '../pages/hearro/patientManage/HearroPatientManageListPage';
import HearroPatientManageDetailPage from '../pages/hearro/patientManage/HearroPatientManageDetailPage';
import HearroNotificationList from '../pages/hearro/pushNotification/HearroNotificationList';
import HearroMyPageMain from '../pages/hearro/mypage/HearroMyPageMain';
import HearroMyPageWithdrawal from '../pages/hearro/mypage/HearroMyPageWithdrawal';
import HearroMyPageModifyProfile from '../pages/hearro/mypage/HearroMyPageModifyProfile';
import HearroMyPageModifyPW from '../pages/hearro/mypage/HearroMyPageModifyPW';
import HearroMyPageLoginHistory from '../pages/hearro/mypage/HearroMyPageLoginHistory';
import MomtheraDashboardPage from '../pages/momthera/dashboard/MomtheraDashboardPage';
import MomtheraPatientManageListPage from '../pages/momthera/patientManage/MomtheraPatientManageListPage';
import MomtheraPatientManageDetailPage from '../pages/momthera/patientManage/MomtheraPatientManageDetailPage';
import MomtheraMyPageMain from '../pages/momthera/mypage/MomtheraMyPageMain';
import MomtheraMyPageWithdrawalGuide from '../pages/momthera/mypage/MomtheraMyPageWithdrawalGuide';
import MomtheraMyPageWithdrawalIdentification from '../pages/momthera/mypage/MomtheraMyPageWithdrawalIdentification';
import MomtheraMyPageModifyPW from '../pages/momthera/mypage/MomtheraMyPageModifyPW';
import MomtheraMyPageModifyPhone from '../pages/momthera/mypage/MomtheraMyPageModifyPhone';
import MomtheraMyPageModifyInstitution from '../pages/momthera/mypage/MomtheraMyPageModifyInstitution';
import AuthBridgePage from '../pages/AuthBridgePage';

function Router() {
	return (
		<Routes>
			<Route exact path="/" element={<Navigate to="/dtx001/dashboard" />} />
			{/* 알코지니 dtx001 */}
			<Route
				path="/dtx001"
				exact
				element={<PrivateRouteAlcohol component={<DashboardLayout type="dtx001" />} />}
			>
				<Route exact path="" element={<Navigate to="/dtx001/dashboard" />} />
				<Route path="dashboard" exact element={<AlcoholDashboardPage />} />
				<Route path="patient-manage/list/*">
					<Route path="" exact element={<AlcoholPatientManageListPage />} />
					<Route path=":pid" exact element={<AlcoholPatientManageDetailPage />} />
				</Route>
				{/* <Route path="system-setting/*">
					<Route path="institution" exact element={<AlcoholSettingInstitution />} />
					<Route path="user" exact element={<AlcoholSettingUser />} />
					<Route path="auth" exact element={<AlcoholSettingAuth />} />
				</Route> */}
				<Route path="push-notification/*" exact element={<AlcoholNotificationList />} />
				<Route path="mypage/*" exact>
					<Route path="" exact element={<AlcoholMyPageMain />} />
					<Route path="withdrawal" exact element={<AlcoholMyPageWithdrawal />} />
					<Route path="modify-profile" exact element={<AlcoholMyPageModifyProfile />} />
					<Route path="modify-pw" exact element={<AlcoholMyPageModifyPW />} />
					<Route path="login-history" exact element={<AlcoholMyPageLoginHistory />} />
					<Route path="activity-history" exact element={<AlcoholMyPageActivityHistory />} />
				</Route>
			</Route>
			{/* 히어로 dtx002 */}
			<Route
				path="/dtx002"
				exact
				element={<PrivateRoute component={<DashboardLayout type="dtx002" />} />}
			>
				<Route exact path="" element={<Navigate to="/dtx002/patient-manage/list" />} />
				<Route path="dashboard" exact element={<HearroDashboardPage />} />
				<Route path="patient-manage/list/*">
					<Route path="" exact element={<HearroPatientManageListPage />} />
					<Route path=":pid" exact element={<HearroPatientManageDetailPage />} />
				</Route>
				<Route path="push-notification/*" exact element={<HearroNotificationList />} />
				<Route path="mypage/*" exact>
					<Route path="" exact element={<HearroMyPageMain />} />
					<Route path="withdrawal" exact element={<HearroMyPageWithdrawal />} />
					<Route path="modify-profile" exact element={<HearroMyPageModifyProfile />} />
					<Route path="modify-pw" exact element={<HearroMyPageModifyPW />} />
					<Route path="login-history" exact element={<HearroMyPageLoginHistory />} />
				</Route>
			</Route>
			{/* 맘테라 dtx006 */}
			<Route
				path="/dtx006"
				exact
				element={<PrivateRouteMomthera component={<DashboardLayout type="dtx006" />} />}
			>
				<Route exact path="" element={<Navigate to="/dtx006/dashboard" />} />
				<Route path="dashboard" exact element={<MomtheraDashboardPage />} />
				<Route path="patient-manage/list/*">
					<Route path="" exact element={<MomtheraPatientManageListPage />} />
					<Route path=":pid" exact element={<MomtheraPatientManageDetailPage />} />
				</Route>
				<Route path="mypage/*" exact>
					<Route path="" exact element={<MomtheraMyPageMain />} />
					<Route path="withdrawal/guide" exact element={<MomtheraMyPageWithdrawalGuide />} />
					<Route
						path="withdrawal/identification"
						exact
						element={<MomtheraMyPageWithdrawalIdentification />}
					/>
					<Route path="modify-pw" exact element={<MomtheraMyPageModifyPW />} />
					<Route path="modify-phone" exact element={<MomtheraMyPageModifyPhone />} />
					<Route path="modify-institution" exact element={<MomtheraMyPageModifyInstitution />} />
				</Route>
			</Route>
			{/* 알코지니(dtx001) 로그인 관련 라우터 */}
			<Route path="sign-in/dtx001" exact element={<SignInPage type="dtx001" />} />
			<Route path="sign-up/dtx001" exact element={<SignUpPage type="dtx001" />} />
			<Route path="change-pw/dtx001/:state" exact element={<ChangePWPage type="dtx001" />} />
			<Route path="search-account/dtx001" exact element={<SearchAccount type="dtx001" />} />

			{/* 히어로(dtx002) 로그인 관련 라우터 */}
			<Route path="sign-in/dtx002" exact element={<SignInPage type="dtx002" />} />
			<Route path="sign-up/dtx002" exact element={<SignUpPage type="dtx002" />} />
			<Route path="change-pw/dtx002/:state" exact element={<ChangePWPage type="dtx002" />} />
			<Route path="search-account/dtx002" exact element={<SearchAccount type="dtx002" />} />

			{/* 맘테라(dtx006) 로그인 관련 라우터 */}
			<Route path="spec/dtx006" exact element={<ProjectSpec title="MOMTHERA" type="dtx006" />} />
			<Route
				path="sign-in/dtx006"
				exact
				element={<SignInPageV2 title="MOMTHERA" type="dtx006" />}
			/>
			<Route path="sign-up/dtx006" exact element={<SignUpPage type="dtx006" />} />
			<Route path="change-pw/dtx006/:state" exact element={<ChangePWPage type="dtx006" />} />
			<Route path="search-account/dtx006" exact element={<SearchAccount type="dtx006" />} />

			<Route path="fail" exact element={<SignInRefusePage />} />
			<Route path="sign-in/:type/systemadmin/auth-bridge" exact element={<AuthBridgePage />} />

			<Route path="*" element={<EmptyPage />} />
		</Routes>
	);
}

export default Router;
